import type { QuoteLineLastWinType } from '../../types/state/quote-line';

export function emptyLastWin(): QuoteLineLastWinType {
  return {
    hasLastWin: false,
    orderId: null,
    orderDate: null,
    wonAt: null,
    quantity: null,
    unitCost: null,
    unitLaborCost: null,
    unitMaterialCost: null,
    unitServiceCost: null,
    unitVariableCosts: null,
    unitPrice: null,
    grossMargin: null,
    contributionMargin: null,
    leadTime: null,
  };
}
